import React from "react"
import Button from "@mui/material/Button"
import CircularProgress from "@mui/material/CircularProgress"

import { Link } from "react-router-dom"
import { Field, reduxForm } from "redux-form"

import BasicField from "../components/BasicField"
import PasswordField from "../components/PasswordField"
import { COLOR, PATH } from "../modules/constants"


const validate = values => {
  const errors = {}
  if (!values.email) {
    errors.email = "required"
  } else if (values.email.length > 50) {
    errors.email = "email address must be 50 characters or less"
  }

  if (!values.password) {
    errors.password = "required"
  }

  return errors
}

const LoginForm = ({ handleSubmit, invalid, submitting }) => {
  /* Set */
  window.prevPath = "/login"
  return (
    <form onSubmit={handleSubmit}>

      <div className="field">
        <Field
          name="email"
          component={BasicField}
          type="text"
          spellCheck={false}
          autoComplete="username email"
          label="Email" />
      </div>

      <div className="field">
        <Field
          name="password"
          component={PasswordField}
          type="password"
          autoComplete="current-password"
          label="Password" />
        <div className="forgot-password-link">
          <Link to={`/${PATH.FORGOT_PASSWORD}`} style={{ color: COLOR.BRAND.STD }} >I forgot my password </Link>
        </div>
      </div>

      <div>
        <Button
          type="submit"
          className="fullWidthButton"
          variant="contained"
          color="primary"
          size="large"
          disabled={invalid || submitting}>
          {submitting ? <CircularProgress size={24} /> : "Log in"}
        </Button>
      </div>
    </form>
  )
}

export default reduxForm({ form: "login", validate })(LoginForm)